/**
 * Récupère les recettes TheMealDB par ingrédient, nom, catégorie, pays
 */

import { mealToRecipe } from "../utils/recipeHelpers.js";

const BASE = "https://www.themealdb.com/api/json/v1/1";

async function fetchDetailsForIds(ids) {
  const details = await Promise.all(
    ids.map((id) =>
      fetch(`${BASE}/lookup.php?i=${id}`)
        .then((r) => r.json())
        .then((data) => data.meals?.[0]),
    ),
  );
  return details.filter(Boolean);
}

export async function fetchFridgeRecipes(
  availableIngredients,
  categories,
  countries,
  translateToEnglish,
) {
  const processedIds = new Set();

  const addMealIds = (meals) => {
    (meals || []).forEach((m) => {
      if (m.strArea === "Thai") return;
      if (!processedIds.has(m.idMeal)) processedIds.add(m.idMeal);
    });
  };

  for (const ingredient of availableIngredients) {
    const englishIngredient = translateToEnglish(ingredient);
    const term = (englishIngredient || ingredient).toLowerCase().trim();

    try {
      const res = await fetch(
        `${BASE}/filter.php?i=${encodeURIComponent(englishIngredient)}`,
      );
      const data = await res.json();
      addMealIds(data.meals?.slice(0, 8));
    } catch (err) {
      console.warn(`Erreur filter.php?i= "${ingredient}":`, err);
    }

    try {
      const res = await fetch(
        `${BASE}/search.php?s=${encodeURIComponent(englishIngredient)}`,
      );
      const data = await res.json();
      (data.meals || []).forEach((m) => {
        if (m.strArea !== "Thai" && !processedIds.has(m.idMeal))
          processedIds.add(m.idMeal);
      });
    } catch (err) {
      console.warn(`Erreur search.php "${ingredient}":`, err);
    }

    const matchedCategory = (categories || []).find(
      (c) =>
        (c.strCategory || "").toLowerCase().includes(term) ||
        term.includes((c.strCategory || "").toLowerCase()),
    );
    if (matchedCategory) {
      try {
        const res = await fetch(
          `${BASE}/filter.php?c=${encodeURIComponent(matchedCategory.strCategory)}`,
        );
        const data = await res.json();
        addMealIds(data.meals?.slice(0, 6));
      } catch (err) {
        console.warn(`Erreur filter.php?c=:`, err);
      }
    }

    const matchedArea = (countries || []).find(
      (c) =>
        (c.strArea || "").toLowerCase().includes(term) ||
        term.includes((c.strArea || "").toLowerCase()),
    );
    if (matchedArea) {
      try {
        const res = await fetch(
          `${BASE}/filter.php?a=${encodeURIComponent(matchedArea.strArea)}`,
        );
        const data = await res.json();
        addMealIds(data.meals?.slice(0, 6));
      } catch (err) {
        console.warn(`Erreur filter.php?a=:`, err);
      }
    }
  }

  const idsToFetch = Array.from(processedIds);
  const mealsWithDetails = await fetchDetailsForIds(idsToFetch);
  const allRecipes = mealsWithDetails.map((m) => mealToRecipe(m));
  return Array.from(new Map(allRecipes.map((r) => [r.id, r])).values());
}
